export const GIFT_CARD_KINDS = ['digital', 'physical'];
/**
 * `pending` is a card minted for an order that is not paid yet — it holds no
 * value and cannot be spent. Paying the order makes it `active`; a refund or an
 * admin void makes it `void`.
 */
export const GIFT_CARD_STATUSES = ['pending', 'active', 'void'];
export const GIFT_CARD_TXN_KINDS = ['issue', 'redeem', 'release', 'refund', 'void'];
export const STORE_CREDIT_TXN_KINDS = ['adjust', 'redeem', 'release', 'refund'];
/** Payment providers that are stored value rather than money moving. */
export const CREDIT_PAYMENT_PROVIDERS = ['gift_card', 'store_credit'];
/**
 * No 0/O, 1/I/L or U — a code read aloud or off a printed card must not be
 * ambiguous. 30 symbols x 16 places is roughly 78 bits.
 */
export const GIFT_CARD_CODE_ALPHABET = '23456789ABCDEFGHJKMNPQRSTVWXYZ';
export const GIFT_CARD_CODE_LENGTH = 16;
export const GIFT_CARD_CODE_PREFIX = 'GC';
/** Upper-cases and strips everything that is not part of the code itself. */
export function normalizeGiftCardCode(input) {
    let code = input.toUpperCase().replace(/[^A-Z0-9]/g, '');
    if (code.startsWith(GIFT_CARD_CODE_PREFIX) && code.length === GIFT_CARD_CODE_LENGTH + 2) {
        code = code.slice(GIFT_CARD_CODE_PREFIX.length);
    }
    return code;
}
/** `GC-XXXX-XXXX-XXXX-XXXX` for display; accepts raw or already-grouped input. */
export function formatGiftCardCode(input) {
    const code = normalizeGiftCardCode(input);
    const groups = code.match(/.{1,4}/g) ?? [];
    return `${GIFT_CARD_CODE_PREFIX}-${groups.join('-')}`;
}
export function isPlausibleGiftCardCode(input) {
    const code = normalizeGiftCardCode(input);
    return (code.length === GIFT_CARD_CODE_LENGTH &&
        [...code].every((ch) => GIFT_CARD_CODE_ALPHABET.includes(ch)));
}
//# sourceMappingURL=gift-cards.js.map